import $ from 'jquery';

$(function () {
	var overlay = $('.overlay');

	$('#open-nav').click(function(e) {
		$('body').addClass('nav-open');
        $('header').addClass('nav-open');
		overlay.fadeIn('200', 'swing', function() { overlay.addClass('open') } );

		if ($('body').hasClass('single-event')) {
			$('.main-nav li a').click(function(e){
				$('body').removeClass('nav-open');
				$('header').removeClass('nav-open');
				overlay.removeClass('open').fadeOut('200', 'swing' );
			});
		}
	});

	$('#close-nav').click(function(e) {
		$('body').removeClass('nav-open');
        $('header').removeClass('nav-open');
		overlay.removeClass('open').fadeOut('200', 'swing' );
	});


});


// WEBPACK FOOTER //
// ./resources/assets/js/components/MobileMenu.js